import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/organizations/downloadOrganizationsLicenses";

export class DownloadOrganizationsLicensesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
        this.responseType = "text";
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand();
    }
}
